module.exports = __webpack_public_path__ + "img/step_2.f51fce5f.png";